import { styled } from "@mui/system";
import backgroundSignalNoiseTexture from "img/mainPage/background-signal-noise-texture.png";

export const SignalNoiseDiv = styled("div")(() => ({
  zIndex: "-5",
  position: "absolute",
  inset: "0px",
  background: `url(${backgroundSignalNoiseTexture}) repeat`,
}));
